export default __webpack_public_path__ + "static/media/15en.657efa42.mp3";